/* export const PROGRAMAS = 5 -
export const ENTIDADES_FINANCIERAS = 35-
export const PROCESOS_CREDITO = 36 -
export const ESTADOS_FINANCIEROS = 37 -
export const MOTIVOS_FINANCIEROS = 38 -
export const TIPOS_FINANCIEROS = 52 -
export const PAGOS_LEGALIZACION = 53 -
export const PECUNIARIOS_LEGALIZACION = 54 -
export const REQUISITOS_CREDITOS = 132 -
export const CREDITO_DIRECTO_POARA = 130 -
export const CREDITO_DIRECTO_OCUPACION = 131 -
export const CODIGO_MODELO_LETRA_CAMBIO = 18281 -
export const LONGITUD_REQUISITOS = 4 -
export const OBSERVACIONES_FINANCIEROS = 64 -
export const SOLICITUDES_DESCONGELAMIENTO = 109 -
export const ORIGEN_DINERO_DESCONGELAMIENTO = 110 -
export const MODALIDADES_CONGELAMIENTO = 111 -
export const REQUISITOS_FINANCIEROS = 112 -
export const TIPOS_DEVOLUCION = 282 -
export const ORIGEN_DINEROS_DEVOLUCION = 283 -
export const CODIGO_ICETEX_DEVOLUCION = 24955 -
export const CODIGO_ENTIDAD_FINANCIERA_DEVOLUCION = 24957 -
export const CODIGO_ABONO_DEVOLUCION = 24953 -
export const RESPUESTAS_FINALIZADO_ESTADO_FINANCIERO = 306  -
export const TIPOS_SOLICITUDES_ESTADO_FINANCIERO = 307 -
export const CODIGO_OTRO_ORIGEN_DEVOLUCION = 'Or_re_otro_dev'
*/

// DESARROLLO

export const PROGRAMAS = 5
export const ENTIDADES_FINANCIERAS = 35 // en produccion 35 local 34
export const PROCESOS_CREDITO = 36 // en produccion 36 local 35
export const ESTADOS_FINANCIEROS = 37 // en produccion 37 local 36
export const MOTIVOS_FINANCIEROS = 38 // en produccion 38 local 37
export const TIPOS_FINANCIEROS = 52 // en produccion 52 local 50
export const PAGOS_LEGALIZACION = 53 // en produccion 53 local 51
export const PECUNIARIOS_LEGALIZACION = 54 // en produccion 54 local 52
export const REQUISITOS_CREDITOS = 132 // en produccion 132 local 130
export const CREDITO_DIRECTO_POARA = 130 // en produccion 130 local 128
export const CREDITO_DIRECTO_OCUPACION = 131 // en produccion 131 local 129
export const CODIGO_MODELO_LETRA_CAMBIO = 18281 // en produccion 18281 local 2753
export const LONGITUD_REQUISITOS = 4 
export const OBSERVACIONES_FINANCIEROS = 64 // en produccion 64 local 62
export const SOLICITUDES_DESCONGELAMIENTO = 109 // en produccion 109 local 107
export const ORIGEN_DINERO_DESCONGELAMIENTO = 110 // en produccion 110 local 108
export const MODALIDADES_CONGELAMIENTO = 111 // en produccion 111 local 109
export const REQUISITOS_FINANCIEROS = 112 // en produccion 112 local 110

export const TIPOS_DEVOLUCION = 282 // en produccion 282  local 215
export const ORIGEN_DINEROS_DEVOLUCION = 283 //en produccion 283  locl 216
export const CODIGO_ICETEX_DEVOLUCION = 24955  //en produccion 24955   local 2815
export const CODIGO_ENTIDAD_FINANCIERA_DEVOLUCION = 24957 // en produccion 24957 local 2817
export const CODIGO_ABONO_DEVOLUCION = 24953 // en produccion 24953 local 2812
export const RESPUESTAS_FINALIZADO_ESTADO_FINANCIERO = 306  // en produccion 306  local 217
export const TIPOS_SOLICITUDES_ESTADO_FINANCIERO = 307 // en produccion 307 local 218
export const CODIGO_OTRO_ORIGEN_DEVOLUCION = 'Or_re_otro_dev'
export const CODIGO_OTRO_ORIGEN_CONGELAMIENTO = 'Or_cong_otos'
export const CODIGO_OTRO_ORIGEN_TRASLADO = 'Or_tras_otros'
export const ORIGEN_RECURSOS_TRASLADO =  396 //en produccion 396 local 220



